(() => {
  async function getCartPayload() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const items = cart.items.map(it => ({
      weight: +(it.grams / 1000).toFixed(3),
      width: +((it.properties && it.properties._width) || 12),
      height: +((it.properties && it.properties._height) || 4),
      length: +((it.properties && it.properties._length) || 16),
      quantity: it.quantity,
      insurance_value: +(it.final_line_price / 100).toFixed(2),
    }));
    return {
      cep: document.getElementById('frete-cep').value.replace(/\D/g, ''),
      items
    };
  }

  async function calcularFrete() {
    const container = document.getElementById('frete-resultados');
    container.innerHTML = '<p>Calculando...</p>';

    const cep = document.getElementById('frete-cep').value.replace(/\D/g, '');
    if (cep.length !== 8) {
      container.innerHTML = '<p>Informe um CEP válido (8 dígitos).</p>';
      return;
    }

    const payload = await getCartPayload();
    console.log('Payload Frete:', payload);

    try {
      const res = await fetch('https://n8n-01-n8n.pa0kts.easypanel.host/webhook/frete-cotacao', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      let data = await res.json();
      // Suporta both array e object
      const services = Array.isArray(data) ? data : (data ? [data] : []);
      console.log('Resposta Frete:', services);

      if (!services.length) {
        container.innerHTML = '<p>Serviço indisponível para este CEP.</p>';
        return;
      }

      // Render todas as cotações
      container.innerHTML = services.map(s => `
        <p><strong>${s.name}</strong>: R$ ${s.price} — ${s.prazo} dia(s) úteis</p>
      `).join('');
    } catch (e) {
      console.error('Erro no fetch de frete:', e);
      container.innerHTML = '<p>Não foi possível calcular o frete. Tente mais tarde.</p>';
    }
  }

  document.addEventListener('click', e => {
    if (e.target.id === 'btn-calcular-frete') {
      calcularFrete();
    }
  });

  console.log('Simulador de frete ativo');
})();
